import { render, staticRenderFns } from "./OrgHomeIntakeStatsPacing.vue?vue&type=template&id=4570a870&scoped=true&"
import script from "./OrgHomeIntakeStatsPacing.vue?vue&type=script&lang=js&"
export * from "./OrgHomeIntakeStatsPacing.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeIntakeStatsPacing.vue?vue&type=style&index=0&id=4570a870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570a870",
  null
  
)

export default component.exports